// extracted by mini-css-extract-plugin
export default {"subscribeCustomerContent":"src-pages-Order-AllOrders-OrderDetail-ParcelProcess-ReadyToPack-css-module__subscribeCustomerContent--60yCS"};